// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"16ee2dfa","52":"e60f30a9","205":"4e33cf8d","235":"4da2c9c5","269":"89826886","346":"f480ea35","434":"ae2b567d","566":"ed53fb31","637":"3f4385b5","670":"fd8c627c","704":"1ff564f3","771":"1bef14ce"}[chunkId] + ".chunk.js";
};